<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <Form ref="form" :model="formData" :rules="rule" :label-width="120">
                <Row>
                    <Col span="12">
                        <FormItem  :label="$t('user_code')" prop="user_code">
                            <Input v-model="user_code" disabled></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem  :label="$t('user_cname')" prop="user_cname">
                            <Input v-model="user_cname" disabled></Input>
                            <input style="width: 0;height:0;border: 0;float: left" />
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('org_level')" prop="org_level">
                            <Select v-model="formData.org_level" :placeholder="$t('select')">
                                <Option :value="item.key" v-for="(item, index) in org_levels" :key="index">{{item.value}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <FormItem :label="$t('select_role')">
                    <CheckboxGroup v-model="formData.cats">
                        <Checkbox v-for="(item, index) in cats" :key="index" :label="item.key">{{item.value}}</Checkbox>
                    </CheckboxGroup>
                </FormItem>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="addRole">{{$t('add_role')}}</Button>
            <Button type="error" @click="deleteRole">{{$t('delete_role')}}</Button>
        </div>
    </div>
</template>

<script>
    export default {
        data:function(){
            return{
                relist:false,
                op: this.$base.getRequest().op,
                org_levels:[],
                formData: {
                    org_level: '',
                    cats: [],
                    u_id: '',
                },
                cats: [],
                user_cname : '',
                user_code: '',
                rule: {
                    org_level: [{required: true, message: this.$t('select'), trigger: 'change'}],
                }
            }
        },
        computed:{
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.user_cname = this.$base.getRequest().user_cname;
            this.user_code = this.$base.getRequest().user_code;
            this.formData.u_id = this.$base.getRequest().u_id;
            this.getLoad();
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getLoad: function(){
                let url = ''
                if (this.$base.getOrgLevel() == '1') {
                    url = 'user-downrole-s1/before-add'
                } else if (this.$base.getOrgLevel() == '2') {
                    url = 'user-downrole-s2/before-add'
                }
                this.$base.showLoading();
                this.$request.sendPost(url,{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.org_levels = data.org_levels.filter(item => item.key > this.$base.getOrgLevel());
                        this.cats = data.cats;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            setRole: function (url) {
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.msgSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.msgErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.msgErr(this.$t('incomplete'));
                    }
                })
            },
           addRole: function () {
               let url = ''
               if (this.$base.getOrgLevel() == '1') {
                   url = 'user-downrole-s1/add-all'
               } else if (this.$base.getOrgLevel() == '2') {
                   url = 'user-downrole-s2/add-all'
               }
               this.setRole(url)
           },
           deleteRole: function () {
               let content = this.$t('confirm_delete');
               let title =  this.$t('tips');
               this.$base.confirm(title,content, () => {
                   let url = ''
                   if (this.$base.getOrgLevel() == '1') {
                       url = 'user-downrole-s1/del-all'
                   } else if (this.$base.getOrgLevel() == '2') {
                       url = 'user-downrole-s2/del-all'
                   }
                   this.setRole(url)
               },()=>{})

           },
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/user/user_setdownrole.vue